const THEME_KEY = 'sukoji:theme'
const THEMES = new Set(['classic', 'ocean', 'berry'])
const THEME_COLORS = { classic: '#f6f2e8', ocean: '#edf3f2', berry: '#f7f0f3' }

function applyTheme(theme) {
  document.documentElement.dataset.theme = theme
  document.querySelector('meta[name="theme-color"]')?.setAttribute('content', THEME_COLORS[theme])
}

export function applySavedTheme() {
  let theme = 'classic'
  try {
    const saved = localStorage.getItem(THEME_KEY)
    if (THEMES.has(saved)) theme = saved
  } catch { /* stockage indisponible */ }
  applyTheme(theme)
  return theme
}

export function saveTheme(theme) {
  const value = THEMES.has(theme) ? theme : 'classic'
  applyTheme(value)
  try { localStorage.setItem(THEME_KEY, value) } catch { /* stockage indisponible */ }
  return value
}
